import Vue from "vue";
import Vuex from "vuex";

import app from "./modules/app";
import errorLog from "./modules/errorLog";
import permission from "./modules/permission";
import tagsView from "./modules/tagsView";
import user from "./modules/user";

import tabStore from "./modules/tabStore"; // tab 切花页面值

import VueOrg from "./modules/vueOrg";

import bmTree from "./modules/bmTree";
import contractDlg from "./modules/contractDlg";
import BmsDialog from "./modules/BmsDialog";
import GwsDialog from "./modules/GwsDialog";
import Usersdialog from "./modules/Usersdialog";
import UsersOrBranDialog from "./modules/UsersOrBranDialog";

import gwTree from "./modules/gwTree";
import holidayDialog from "./modules/holidayDialog";
import mapDialog from "./modules/mapDialog";
import mapDialog2 from "./modules/mapDialog2";
import kqDialog from "./modules/kqDialog";
import Imgenlarge from "./modules/imgenlarge";
import Usertree from "./modules/userTree";
import Dmantable from "./modules/dmanTable";
import Facedialog from "./modules/faceDialog";
import NavTag from "./modules/NavTag";
import processMan from "./modules/processMan"; // 业务协同

import HsbmsDialog from "./modules/HsbmsDialog"; // 核算部门 多选，配置比例
import HsbmDialog from "./modules/HsbmDialog"; // 核算部门 单选

import Branchtree from "./modules/branchTree"; // 多选部门树

import dialogStore from "./modules/dialogStore"; // 多选权限树

import processBase from "./modules/processBase"; // 工作流流程模块
import financialSystem from "./modules/financialSystem"; // 财务系统模块
import supplyAssetMan from "./modules/supplyAssetMan"; // 供应链资产
import supplyChainMan from "./modules/supplyChainMan"; // 供应链模块
import platformSystem from "./modules/platformSystem"; // 平台管理模块
import platformMan from "./modules/platformMan"; // 平台管理模块
import clothingMan from "./modules/clothingMan"; // 被服管理模块
import propertyMan from "./modules/propertyMan"; //  运营管理模块
import qualitySystem from "./modules/qualitySystem"; //  品质系统
import reportMan from "./modules/reportMan"; //  报事系统
import customerCenter from "./modules/customerCenter"; //  客服中心
import businessBase from "./modules/businessBase"; // 业务模块

import administrativeMan from "./modules/administrativeMan"; // 行政管理

import getters from "./getters";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 工作流
    nodeMap: new Map(),
    isEdit: null,
    loginUser: JSON.parse(localStorage.getItem("loginUser") || "{}"),
    selectedNode: {},
    selectFormItem: null,
    design: {},

    medicalSocketIn: null,
    medicalSocket: null,

  },

  modules: {
    app,
    errorLog,
    permission,
    tagsView,
    user,

    tabStore, // tab 切换值

    VueOrg,
    bmTree,
    contractDlg,
    BmsDialog,
    GwsDialog,
    Usersdialog,
    UsersOrBranDialog,
    gwTree,
    holidayDialog,
    mapDialog,
    mapDialog2,
    kqDialog,
    Imgenlarge,
    Usertree,
    Dmantable,
    Facedialog,
    NavTag,
    processMan,
    HsbmsDialog,
    HsbmDialog,
    Branchtree,
    dialogStore,
    processBase, // 工作流模块
    financialSystem, // 财务系统模块
    supplyAssetMan, // 供应链资产
    administrativeMan, // 行政管理
    supplyChainMan, // 供应商模块
    platformSystem, // 平台管理模块
    platformMan,
    clothingMan,
    propertyMan, // 运营管理模块
    qualitySystem, // 品质系统模块
    reportMan,
    customerCenter,
    businessBase
  },
  getters,
  mutations: {
    // 工作流
    selectedNode(state, val) {
      state.selectedNode = val;
    },
    loadForm(state, val) {
      state.design = val;
    },
    setIsEdit(state, val) {
      state.isEdit = val;
    },
    setLoginUser(state, val) {
      state.loginUser = val;
    },

    setMedicalSocketIn(state, val) {
      state.medicalSocketIn = val;
    },
    setMedicalSocket(state, val) {
      state.medicalSocket = val;
    },
    

  }
});

export default store;
